import React from 'react';
import { ButtonBase as MuiButtonBase } from '@material-ui/core';

const ButtonBase = props => <MuiButtonBase {...props} />;

export default ButtonBase;
